"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleForemanPowerCircuitPhaseHeightFieldJoin = void 0;
const field_join_ikecalc_1 = require("./field.join.ikecalc");
const POWER_CIRCUIT_PHASE_HEIGHTS = [
    'ipf_spanPowerCircuitPrimaryPhaseAHeight',
    'ipf_spanPowerCircuitPrimaryPhaseBHeight',
    'ipf_spanPowerCircuitPrimaryPhaseCHeight',
    'ipf_spanPowerCircuitSecondaryPhaseAHeight',
    'ipf_spanPowerCircuitSecondaryPhaseBHeight',
    'ipf_spanPowerCircuitSecondaryPhaseCHeight',
    'ipf_spanPowerCircuitShieldWireHeight',
    'ipf_spanPowerCircuitNeutralHeight'
];
class PoleForemanPowerCircuitPhaseHeightFieldJoin extends field_join_ikecalc_1.IkeCalcFieldJoin {
    static accepts(field) {
        return POWER_CIRCUIT_PHASE_HEIGHTS.indexOf(field.schema.id) > -1;
    }
    constructor(field) {
        super(field);
        this.type = 'PoleForemanPowerCircuitPhaseHeightJoin';
    }
    /**
     * Check if this field can join with another field by checking if they match framing and conductor types.
     * @param other - The other field to check.
     * @returns True if the field is a power circuit phase height field and matches the other field's framing and conductor types.
     */
    joins(other) {
        const joinableHeight = this.getFieldValue(this.circuit, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        // Determine which field type this is
        const id = this.field.schema.id;
        const isPrimary = id.startsWith('ipf_spanPowerCircuitPrimary');
        const isSecondary = id.startsWith('ipf_spanPowerCircuitSecondary');
        const isShieldWire = id === 'ipf_spanPowerCircuitShieldWireHeight';
        const isNeutral = id === 'ipf_spanPowerCircuitNeutralHeight';
        // Use correct framing/conductor fields for matching
        let framingField = '';
        let conductorField = '';
        if (isPrimary) {
            framingField = 'ipf_spanPowerCircuitPrimaryFraming';
            conductorField = 'ipf_spanPowerCircuitPrimaryConductor';
        }
        else if (isSecondary) {
            framingField = 'ipf_spanPowerCircuitSecondaryFraming';
            conductorField = 'ipf_spanPowerCircuitSecondaryConductor';
        }
        else if (isShieldWire) {
            framingField = 'ipf_spanPowerCircuitShieldWireFraming';
            conductorField = 'ipf_spanPowerCircuitShieldWireConductor';
        }
        else if (isNeutral) {
            framingField = 'ipf_spanPowerCircuitNeutralFraming';
            conductorField = 'ipf_spanPowerCircuitNeutralConductor';
        }
        else {
            return false;
        }
        const framingType = this.getFieldValue(this.circuit, framingField);
        if (this.isDeadend(framingType)) {
            return false;
        }
        if (!other.circuit.hasField(id) || this.getFieldValue(other.circuit, id) != null) {
            return false;
        }
        return this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.circuit, other.circuit, framingField) &&
            this.fieldsEqual(this.circuit, other.circuit, conductorField) &&
            this.fieldsEqual(this.circuit, other.circuit, 'ipf_spanPowerCircuitType');
    }
    // Check if the spans are opposing (i.e., one is a fore span and the other is a back span)
    spansOpposing(spanA, spanB) {
        if (spanA.instanceId === spanB.instanceId ||
            !spanA.hasField('ipf_spanType') ||
            !spanB.hasField('ipf_spanType')) {
            return false;
        }
        const spanAType = spanA.getField('ipf_spanType').value;
        const spanBType = spanB.getField('ipf_spanType').value;
        if (!spanAType || !spanBType) {
            return false;
        }
        const validTypes = ['fore_span', 'back_span', 'other'];
        if (validTypes.includes(spanAType) &&
            validTypes.includes(spanBType) &&
            spanAType !== spanBType) {
            return true;
        }
        return false;
    }
}
exports.PoleForemanPowerCircuitPhaseHeightFieldJoin = PoleForemanPowerCircuitPhaseHeightFieldJoin;
//# sourceMappingURL=field.join.poleforeman.powercircuit.js.map